import { differenceInDays } from 'date-fns';

export const daysLeftCalculation = (fallbackGpEndDate: Date, gpEndDate?: Date) =>
	differenceInDays(gpEndDate ? new Date(gpEndDate) : fallbackGpEndDate, new Date(Date.now()));
